export enum AI {
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=367451929 */
    PROMPT_TIPS = 'WREX_AI.GENERATE_CONTENT_TIPS',
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=367453535 */
    PROMPT_TIPS_KEYWORDS = 'WREX_AI.GENERATE_CONTENT_TIPS_2',
    /** https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=367460206 */
    PROMPT_TIPS_QUESTIONS = 'WREX_AI.GENERATE_CONTENT_TIPS_3',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=534611171
     */
    GOOD_RESPONSE = 'ASK_AI.GOOD_RESPONSE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=460866431
     */
    BAD_RESPONSE = 'ASK_LUMAPPS.BAD_RESPONSE',
}
